import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import './viewSponsors.css';

// Sponsor strip on /convention/:id. Every sponsor is rendered as an
// equal-height, padded, rounded white tile so logos of any aspect ratio
// line up. The tile is white on purpose: sponsor logos are drawn for light
// backgrounds and the surrounding card is dark in darkmode.
@observer
class ConventionViewSponsors extends Component {
    renderTile(sponsor, meta) {
        const name = meta.name || sponsor.name || 'Sponsor';
        const logo = (
            <img
                class='convention-sponsor-logo'
                src={sponsor.s3LargeLink}
                alt={name}
                loading='lazy'
            />
        );
        if (meta.url) {
            return (
                <a
                    class='convention-sponsor-tile'
                    href={meta.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    title={name}
                >
                    {logo}
                </a>
            );
        }
        return (
            <div class='convention-sponsor-tile' title={name}>
                {logo}
            </div>
        );
    }

    render() {
        const { userStore, conventionStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        // `convention` defaults to `{}` because a not-found / inaccessible convention
        // loads as `undefined` (see the updateItem guard in stores/convention.js).
        const { convention = {} } = conventionStore;
        const sponsors = convention.sponsors || [];
        if (sponsors.length === 0) {
            return null;
        }
        const sponsorsMeta = convention.sponsorsMeta || [];

        return (
            <div class='w-100 d-flex flex-column mt-3'>
                <div class={`convention-sponsors d-flex flex-column mx-3 px-3 pt-2 pb-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                    <div class='convention-sponsors-header d-flex flex-row align-items-center py-2'>
                        <i class='fa-duotone fa-handshake text-primary me-2' style='font-size: 1.5em;' />
                        <span class='text-muted font-weight-light'>
                            <Text id='convention.sponsors'>Sponsors</Text>
                        </span>
                        <small class='text-body-tertiary ms-auto'>
                            <Text id='convention.sponsors-thanks'>Thanks to our sponsors</Text>
                        </small>
                    </div>
                    <div class='row g-3 justify-content-center'>
                        {sponsors.map((sponsor, idx) => {
                            const meta = sponsorsMeta[idx] || {};
                            return (
                                <div
                                    key={sponsor.s3LargeLink || idx}
                                    class='convention-sponsor-cell col-6 col-md-4 col-lg-3 d-flex flex-column align-items-center'
                                >
                                    {this.renderTile(sponsor, meta)}
                                    {meta.name && (
                                        <div class='convention-sponsor-name mt-2 small font-weight-bold text-center'>
                                            {meta.name}
                                        </div>
                                    )}
                                    {meta.description && (
                                        <div class='convention-sponsor-description small text-muted text-center'>
                                            {meta.description}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
export default ConventionViewSponsors;
